(function () {
  'use strict';
  if (customElements.get('home-achievements')) return;

  class HomeAchievements extends HTMLElement {
    connectedCallback() {
      this.marquee = this.querySelector('.home-achievements__marquee');
      this.track = this.querySelector('.home-achievements__track');
      this.group = this.querySelector('[data-original-group]');
      if (!this.marquee || !this.group) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.isConnected) this.build();
        });
      };
      this.onSelect = (event) => {
        const logo = event.target.closest('.home-achievements__logo');
        if (!logo || !this.contains(logo)) return;
        this.setAttribute('data-editor-selected', '');
        const offset = Math.min(logo.offsetLeft, Math.max(0, this.group.offsetWidth - this.marquee.clientWidth));
        this.style.setProperty('--editor-offset', -offset + 'px');
      };
      this.onDeselect = () => this.removeAttribute('data-editor-selected');
      this.addEventListener('shopify:block:select', this.onSelect);
      this.addEventListener('shopify:block:deselect', this.onDeselect);
      this.motion.addEventListener('change', this.schedule);
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.marquee);
      this.schedule();
    }

    copy(element) {
      const clone = element.cloneNode(true);
      clone.removeAttribute('data-original-group');
      clone.setAttribute('data-marquee-copy', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      [clone, ...clone.querySelectorAll('*')].forEach((node) => {
        node.removeAttribute('id');
        node.removeAttribute('data-shopify-editor-block');
        node.removeAttribute('data-shopify-editor-block-id');
      });
      clone.querySelectorAll('img').forEach((img) => { img.alt = ''; });
      return clone;
    }

    build() {
      this.removeAttribute('data-ready');
      this.track.querySelectorAll('[data-marquee-copy]').forEach((copy) => copy.remove());
      const originals = Array.from(this.group.children);
      if (!originals.length || this.motion.matches || this.marquee.clientWidth === 0) return;
      // A full cycle must cover the viewport, even when only one logo is configured.
      const cycleWidth = this.group.getBoundingClientRect().width;
      if (cycleWidth <= 0) return;
      const repetitions = Math.ceil(this.marquee.clientWidth / cycleWidth);
      for (let repeat = 1; repeat < repetitions; repeat++) {
        originals.forEach((logo) => this.group.appendChild(this.copy(logo)));
      }
      const distance = this.group.getBoundingClientRect().width;
      this.track.appendChild(this.copy(this.group));
      const speed = Math.max(10, Math.min(100, Number(this.dataset.speed) || 40));
      this.style.setProperty('--marquee-distance', distance + 'px');
      this.style.setProperty('--marquee-duration', distance / speed + 's');
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.observer) this.observer.disconnect();
      if (this.motion && this.schedule) this.motion.removeEventListener('change', this.schedule);
      this.removeEventListener('shopify:block:select', this.onSelect);
      this.removeEventListener('shopify:block:deselect', this.onDeselect);
    }
  }
  customElements.define('home-achievements', HomeAchievements);
})();
